"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var constants_1 = require("common/constants");
var ModalBody = (0, styles_1.styled)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        // borderBottom: '1px solid rgba(112, 119, 124, 0.35)',
        color: constants_1.COLORS.riverstone,
        paddingTop: theme.spacing(2),
        borderTop: '1px solid rgba(112, 119, 124, 0.35)',
        overflow: 'auto',
        scrollbarWidth: 'thin',
    });
});
exports.default = ModalBody;
